<template>
  <div>
    <v-stepper-step step="5">
      <h3>REVIEW</h3>
      <div class="text-caption">
        Review the details you entered before submitting the declaration.
      </div>
    </v-stepper-step>
    <v-stepper-content step="5">
      <v-row>
        <v-col cols="12" md="6">
          <fieldset class="sr-only-fieldset">
            <legend class="sr-only">Review sender information</legend>
            <div>Sender</div>
            <div class="text-sm-body-2 text-body-2">
              <v-container>
                <v-row no-gutters>
                  <v-col cols="4" md="3">
                    <span> Name: </span>
                  </v-col>
                  <v-col cols="8" md="8">
                    <span>
                      {{ currentDeclaration.sender.name }}
                      {{ currentDeclaration.sender.surname }}
                    </span>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4" md="3">
                    <span> Address: </span>
                  </v-col>
                  <v-col cols="8" md="8">
                    <span>{{ currentDeclaration.sender.addressLine1 }}</span>
                    <span v-if="currentDeclaration.sender.addressLine2"
                      ><br />{{ currentDeclaration.sender.addressLine2 }}</span
                    >
                    <span><br />{{ currentDeclaration.sender.postcode }}</span>
                    <span><br />{{ currentDeclaration.sender.locality }}</span>
                    <span
                      ><br />{{
                        getCountryNameById(currentDeclaration.sender.countryId)
                      }}</span
                    >
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="currentDeclaration.sender.email">
                  <v-col cols="4" md="3">
                    <span> Email: </span>
                  </v-col>
                  <v-col cols="8" md="8">
                    <span>
                      {{ currentDeclaration.sender.email }}
                    </span>
                  </v-col>
                </v-row>

                <v-row no-gutters v-if="currentDeclaration.sender.phone">
                  <v-col cols="4" md="3">
                    <span> Phone: </span>
                  </v-col>
                  <v-col cols="8" md="8">
                    <span>
                      {{ currentDeclaration.sender.phone }}
                    </span>
                  </v-col>
                </v-row>

                <v-row no-gutters v-if="currentDeclaration.sender.vatNumber">
                  <v-col cols="4" md="3">
                    <span> Vat No: </span>
                  </v-col>
                  <v-col cols="8" md="8">
                    <span>
                      {{ currentDeclaration.sender.vatNumber }}
                    </span>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="currentDeclaration.sender.voecNumber && getCountryRequiresVoec(currentDeclaration.recipient.countryId)">
                  <v-col cols="4" md="3">
                    <span> VOEC No: </span>
                  </v-col>
                  <v-col cols="8" md="8">
                    <span>
                      {{ currentDeclaration.sender.voecNumber }}
                    </span>
                  </v-col>
                </v-row>

              </v-container>
            </div>
          </fieldset>

          <fieldset class="sr-only-fieldset" v-if="currentDeclaration.sender && currentDeclaration.sender.consignor">
            <legend class="sr-only">Review consignor information</legend>
            <div class="mt-4">Consignor</div>
            <div class="text-sm-body-2 text-body-2">
              <v-container>
                <v-row no-gutters>
                  <v-col cols="4" md="3">
                    <span> Name: </span>
                  </v-col>
                  <v-col cols="8" md="8">
                    <span>
                      {{ currentDeclaration.sender.consignor.name }}
                      {{ currentDeclaration.sender.consignor.surname }}
                    </span>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="4" md="3">
                    <span> Phone: </span>
                  </v-col>
                  <v-col cols="8" md="8">
                    <span>
                      {{ currentDeclaration.sender.consignor.phone }}
                    </span>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="4" md="3">
                    <span> ID/Passport Number: </span>
                  </v-col>
                  <v-col cols="8" md="8">
                    <span>
                      {{ currentDeclaration.sender.consignor.idNumber }}
                    </span>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="12">
                    <em class="grey--text text--darken-1">
                      Note: Consignor ID/Passport number will be requested upon parcel deposit at the postal counter.
                    </em>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </fieldset>
        </v-col>

        <v-col cols="12" md="6">
            <fieldset class="sr-only-fieldset">
              <legend class="sr-only">Review recipient information</legend>
              <div>Recipient</div>
              <div class="text-sm-body-2 text-body-2">
                <v-container>
                  <v-row no-gutters>
                    <v-col cols="4" md="3">
                      <span> Name: </span>
                    </v-col>
                    <v-col cols="8" md="8">
                      <span>
                        {{ currentDeclaration.recipient.name }}
                        {{ currentDeclaration.recipient.surname }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="4" md="3">
                      <span> Address: </span>
                    </v-col>
                    <v-col cols="8" md="8">
                      <span>{{ currentDeclaration.recipient.addressLine1 }}</span>
                      <span v-if="currentDeclaration.recipient.addressLine2"
                        ><br />{{ currentDeclaration.recipient.addressLine2 }}</span
                      >
                      <span><br />{{ currentDeclaration.recipient.postcode }}</span>
                      <span><br />{{ currentDeclaration.recipient.locality }}</span>
                      <span
                        ><br />{{
                          getCountryNameById(currentDeclaration.recipient.countryId)
                        }}</span
                      >
                    </v-col>
                  </v-row>

                  <v-row no-gutters v-if="currentDeclaration.recipient.email">
                    <v-col cols="4" md="3">
                      <span> Email: </span>
                    </v-col>
                    <v-col cols="8" md="8">
                      <span>
                        {{ currentDeclaration.recipient.email }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="currentDeclaration.recipient.phone">
                    <v-col cols="4" md="3">
                      <span> Phone: </span>
                    </v-col>
                    <v-col cols="8" md="8">
                      <span>
                        {{ currentDeclaration.recipient.phone }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="currentDeclaration.recipient.vatNumber">
                    <v-col cols="4" md="3">
                      <span> Vat No: </span>
                    </v-col>
                    <v-col cols="8" md="8">
                      <span>
                        {{ currentDeclaration.recipient.vatNumber }}
                      </span>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </fieldset>
        </v-col>
      </v-row>

      <fieldset class="sr-only-fieldset">
        <legend class="sr-only">Review category of parcel content</legend>
        <div>Category of Parcel Content</div>
        <div class="text-sm-body-2 text-body-2">
          <v-container style="margin-bottom: 10px">
            {{ currentDeclaration.contentCategory }}
            <span v-if="requiresContentCategoryDescription"
              >({{ currentDeclaration.contentCategoryDescription }})</span
            >
          </v-container>
        </div>
      </fieldset>

      <fieldset class="sr-only-fieldset" v-if="currentDeclaration.recipient.isRequiresContentItems">
        <legend class="sr-only">Review content items</legend>
        <div>Content Items</div>
        <div
          class="text-sm-body-2 text-body-2"
          style="padding-bottom: 20px"
        >
          <v-expansion-panels class="d-md-none" :hover="true">
            <v-expansion-panel
              v-for="item in currentDeclaration.contentItems"
              :key="item.key"
            >
              <v-expansion-panel-header>{{
                item.description
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <dl class="content-item-list">
                  <dt class="font-weight-bold">DESCRIPTION: </dt>
                  <dd>{{ item.description }}</dd>

                  <dt class="font-weight-bold">HS CODE: </dt>
                  <dd>{{ item.hsCode }}</dd>

                  <dt class="font-weight-bold">COUNTRY OF ORIGIN: </dt>
                  <dd>{{ getCountryNameById(item.countryOfOriginId) }}</dd>

                  <dt class="font-weight-bold">TOTAL QUANTITY: </dt>
                  <dd>{{ item.quantity }}</dd>

                  <dt class="font-weight-bold">TOTAL VALUE (€): </dt>
                  <dd>{{ item.value }}</dd>

                  <dt class="font-weight-bold">TOTAL NET WEIGHT (grams): </dt>
                  <dd>{{ item.weight }}</dd>
                </dl>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-simple-table class="d-none d-md-block">
            <template v-slot:default>
              <thead>
                <tr>
                  <th scope="col" class="text-left">Description</th>
                  <th scope="col" class="text-left">HS Code</th>
                  <th scope="col" class="text-left">Country of Origin</th>
                  <th scope="col" class="text-left">Total Quantity</th>
                  <th scope="col" class="text-left">Total Value (&euro;)</th>
                  <th scope="col" class="text-left">Total Net Weight (g)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in currentDeclaration.contentItems"
                  :key="item.key"
                >
                  <td scope="row">{{ item.description }}</td>
                  <td>{{ item.hsCode }}</td>
                  <td>{{ getCountryNameById(item.countryOfOriginId) }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.value }}</td>
                  <td>{{ item.weight }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </fieldset>

      <v-container fluid>
        <v-checkbox v-model="declarationAgreementAccepted">
          <template v-slot:label>
            <div>
              I certify that the particulars given in this Customs declaration
              are correct and that this item does not contain any dangerous
              article(s) prohibited by legislation or by postal or Customs
              regulation. For more information regarding dangerous goods, please
              follow the
              <a
                target="_blank"
                rel="noopener"
                href="https://www.maltapost.com/prohibited"
                v-on:click.stop="on"
                >MaltaPost guidance page</a
              >.
            </div>
          </template>
        </v-checkbox>
      </v-container>
      <vue-recaptcha
        class="mb-6"
        @verify="recaptchaVerified"
        :sitekey="recaptchaSiteKey"
        :loadRecaptchaScript="true"
      ></vue-recaptcha>
      <v-btn
        color="primary"
        :disabled="disableSubmit"
        :aria-disabled="disableSubmit"
        @click="submitDeclaration()"
      >
        Submit Declaration
      </v-btn>
      <div
        class="sr-only"
        aria-live="polite"
        v-if="disableSubmit"
      >
        Please complete all required fields before submitting the declaration.
      </div>

      <v-btn text 
        @click="currentStep = 4" 
        :disabled="disableBack"
        :aria-disabled="disableBack"
        aria-label="Go back to step 4 to specify sender information">
        Back
      </v-btn>

      <v-progress-circular
        indeterminate
        color="primary"
        v-if="saving"
      ></v-progress-circular>
    </v-stepper-content>
  </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("declarations");

export default {
  components: {
    VueRecaptcha,
  },
  data: () => ({
    isRecaptchaValid: false,
    recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
  }),
  computed: {
    ...mapGetters([
      "currentDeclaration",
      "countries",
      "requiresContentCategoryDescription",
      "sendingDocument",
    ]),
    currentStep: {
      set(currentStep) {
        this.$store.dispatch("declarations/setCurrentStep", currentStep);
      },
      get() {
        return this.$store.getters["declarations/currentStep"];
      },
    },
    saving: {
      set(saving) {
        this.$store.dispatch("declarations/setSaving", saving);
      },
      get() {
        return this.$store.getters["declarations/saving"];
      },
    },
    declarationAgreementAccepted: {
      set(declarationAgreementAccepted) {
        this.$store.dispatch(
          "declarations/Step05Review/setDeclarationAgreementAccepted",
          declarationAgreementAccepted
        );
      },
      get() {
        return this.$store.state.declarations.Step05Review
          .declarationAgreementAccepted;
      },
    },
    disableSubmit() {
      return (
        !this.declarationAgreementAccepted ||
        this.saving ||
        !this.isRecaptchaValid
      );
    },
    disableBack() {
      return this.saving;
    },
  },
  methods: {
    getCountryNameById: function (id) {
      if (id) {
        const country = this.countries.find(function (country) {
          return country.id === id;
        });
        return country ? country.name : "";
      }
      return "";
    },
    getCountryRequiresVoec: function (id) {
      if (id) {
        const country = this.countries.find(function (country) {
          return country.id === id;
        });
        return country ? country.requireVOEC : false;
      }
      return false;
    },

    submitDeclaration: function () {
      this.saving = true;
      this.$store.dispatch("declarations/submitDeclaration");
    },
    recaptchaVerified: function (recaptchaToken) {
      this.isRecaptchaValid = true;
      this.currentDeclaration.recaptchaToken = recaptchaToken;
    },
  },
};
</script>